import { OperatorFunction, Observable, map, catchError, of, startWith } from 'rxjs';

export interface AsyncState<T> {
  inProgress: boolean;
  hasError: boolean;
  errorMessage: string | null;
  data: T | null;
}

export function toAsyncState<T>(): OperatorFunction<T, AsyncState<T>> {
  return (source$: Observable<T>) =>
    source$.pipe(
      map<T, AsyncState<T>>(data => ({
        inProgress: false,
        hasError: false,
        errorMessage: null,
        data,
      })),
      catchError(err =>
        of<AsyncState<T>>({
          inProgress: false,
          hasError: true,
          errorMessage: err?.message ?? 'An error occurred',
          data: null,
        }),
      ),
      startWith<AsyncState<T>>({
        inProgress: true,
        hasError: false,
        errorMessage: null,
        data: null,
      }),
    );
}
